import {
  createResource,
  postResource,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const MODEL = 'modal-config'

const MODAL_CONFIG_LIST = prefixAPI('/campaign/list/{?url}', MODEL)
const MODAL_CONFIG_VIEW = prefixAPI('/campaign/viewed/', MODEL)

export const modalConfigListResource = createResource(MODAL_CONFIG_LIST)
export const modalConfigViewResource = createResource(MODAL_CONFIG_VIEW, postResource)
